import money from "astrid-helpers/src/money";

import Table from "../../../ui/components/Table/Table";

import useOpenCostsTableColumns from "./hooks/useOpenCostsTableColumns";

const getSubRows = (row) => (row.costs?.length > 1 ? row.costs : []);

export default function OpenCostsTable({
	costs,
	partyId,
	currency,
	production,
	totalOpenAmount,
	totalEstimatedOpenAmount,
	...props
}) {
	const columns = useOpenCostsTableColumns({ partyId, production });

	return (
		<Table expandable data={costs} columns={columns} getSubRows={getSubRows} {...props}>
			{costs.length > 0 && (
				<Table.Row textAlign={"right"} style={{ fontWeight: "bold" }}>
					<Table.Cell></Table.Cell>
					<Table.Cell></Table.Cell>
					<Table.Cell></Table.Cell>
					<Table.Cell>{money(totalEstimatedOpenAmount, currency)}</Table.Cell>
					<Table.Cell>{money(totalOpenAmount, currency)}</Table.Cell>
					<Table.Cell></Table.Cell>
				</Table.Row>
			)}
		</Table>
	);
}
